export var PublicationStatus;
(function (PublicationStatus) {
    PublicationStatus[PublicationStatus["DRAFT"] = 0] = "DRAFT";
    PublicationStatus[PublicationStatus["PUBLISHED"] = 1] = "PUBLISHED";
    PublicationStatus[PublicationStatus["READY"] = 2] = "READY";
    PublicationStatus[PublicationStatus["DELETED"] = 3] = "DELETED";
    PublicationStatus[PublicationStatus["UNPUBLISHED_CHANGES"] = 5] = "UNPUBLISHED_CHANGES";
    PublicationStatus[PublicationStatus["DELETED_PERMANENTLY"] = 20] = "DELETED_PERMANENTLY";
})(PublicationStatus || (PublicationStatus = {}));
//# sourceMappingURL=publication-status.enum.js.map